import { Body1, Body2, UIHeading4 } from '@cian/ui-kit';
import { IconFinanceSale16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './NewbuildingPurchaseGiftBanner.css';

export interface INewbuildingPurchaseGiftBannerProps {
  title: string;
  subtitle: string;
  linkText: string;
  onClick(): void;
}

/**
 * Баннер-строка акции «30 000 ₽ за покупку квартиры» под промо-полосой карточки ЖК.
 * Своя вёрстка по макету (ui-kit EntryPoint добавляет шеврон к контролу и даёт другие размеры).
 * Кликабельна целиком, «Подробнее» — визуальная подсказка; снизу оранжевая «стопка».
 */
export const NewbuildingPurchaseGiftBanner = ({
  title,
  subtitle,
  linkText,
  onClick,
}: INewbuildingPurchaseGiftBannerProps) => {
  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick();
      }
    },
    [onClick],
  );

  return (
    <div className={styles['container']} data-testid="NewbuildingPurchaseGiftBanner">
      <div className={styles['row']} role="button" tabIndex={0} onClick={onClick} onKeyDown={handleKeyDown}>
        <span className={styles['icon']}>
          <IconFinanceSale16 color="icon-inverted-default" />
        </span>
        <span className={styles['text']}>
          <Body1 fontWeight="bold">{title}</Body1>
          <Body2 color="text-secondary-default">{subtitle}</Body2>
        </span>
        <span className={styles['link']}>
          <UIHeading4 color="accent-main-primary">{linkText}</UIHeading4>
        </span>
      </div>
    </div>
  );
};
